export interface ProductsExploration {
  pendingTransactions: string[]
  productExplorationEnabled: boolean
}

export const DEFAULT_PBX_PRODUCTS_EXPLORATION: ProductsExploration = {
  pendingTransactions: [],
  productExplorationEnabled: false,
}
